import { ListItem, ListItemText, Typography } from '@mui/material'
import { FC, PropsWithChildren, ReactNode } from 'react'

type Props = PropsWithChildren<{
    endButton?: ReactNode
}>

export const NavigationGroupTitle: FC<Props> = ({ children, endButton }) => {
    return (
        <ListItem
            sx={{
                p: 0,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}>
            <ListItemText
                sx={{
                    p: 1,
                    pr: 0,
                    m: 0,
                }}>
                <Typography variant="body2" color="#5A5F72">
                    {children}
                </Typography>
            </ListItemText>
            {endButton}
        </ListItem>
    )
}
